module.exports = __webpack_public_path__ + "img/doc_upload_icon.bc1958bc.png";